import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import CollegeTable from './index'
import { SectionWrapper, TopHeader, TopHeading, PaddedDiv } from '../../../Onboarding/Styles/style'
import Button from 'components/Button/index'
import Toggle from 'components/UIComponents/Toggle'
import PlusIcon from 'components/icons/PlusIcon'
import TableSearchFilter from 'components/UIComponents/TableSearchFilter'
import CountDetails from '../../../Onboarding/Components/CountDetails'
import { fetchFeatureInstitutes, fetchFeatureCorporate } from '../../actions'


const CollegeTableMain = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [page, setPage] = useState(0)
  const [loading, setLoading] = useState(false)
  const [sort, setSort] = useState('')
  const [orderBy, setOrderBy] = useState('')
  const [search, setSearch] = useState('')
  const [showAssignSubscription, setShowAssignSubscription] = useState(false)
  const [current, setCurrent] = useState(true) // true for Corporates, false for Institutes
  const [filterData, setFilterData] = useState({})
  const [collegeStatus, setCollegeStatus] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [instituteList, setInstituteList] = useState([])
  const [corporateList, setCorporateList] = useState([])
  const [clearInput,setClearInput]=useState(false)
  const handlePageChange = (newPage) => {
    setPage(newPage - 1)
  }

 

  useEffect(() => {
    setIsLoading(true)
    if (current) {
      fetchCorporateList()
    } else {
      fetchInstituteList()
    }
  }, [page, search, sort, orderBy, current])
  
  const fetchInstituteList = async () => {
    try {
      const response = await dispatch(fetchFeatureInstitutes(page, search, orderBy, sort))
      setInstituteList(response)
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
    }
  }
  
  const fetchCorporateList = async () => {
    try {
      const response = await dispatch(fetchFeatureCorporate(page, search, orderBy, sort))
      setCorporateList(response)
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
    }
  }
  
  useEffect(() => {
    setPage(0) // Reset to first page when filters change
  }, [search, filterData, sort, orderBy, current])

  // Format institute list to match expected structure
  const collegeList = {
    list: instituteList || [],
    count: instituteList?.length || 0,
    totalCount: instituteList?.length || 0
  }
  
  // Format corporate list to match expected structure
  const corporateListData = {
    list: corporateList || [],
    count: corporateList?.length || 0,
    totalCount: corporateList?.length || 0
  }

  const onClick = (e) => {
    setClearInput(true)
    setSearch('')
    setPage(0)
    setCurrent(!e)
  
  }

  const navigateToAssignSubscription = () => {
    navigate('/assessmentAssignSubscription')
  }

  return (
    <SectionWrapper column id="root-Container">
      <div>
        <TopHeader row spaceBetween alignCenter>
          <TopHeading flexStart>Feature Access</TopHeading>
          <Button.Primary
            width="200px"
            text="Assign subscription"
            icon={<PlusIcon width="16px" height="16px" />}
            onClick={navigateToAssignSubscription}
          />
        </TopHeader>
        <TopHeader row spaceBetween alignCenter>
          <TopHeading flexStart>
            <Toggle
              left="Corporates"
              right="Institutes"
              initialValue={current ? 'left' : 'right'}
              onClick={e => onClick(e)}
            />
          </TopHeading>
        </TopHeader>
        
        {/* Count Details Cards */}
        
        
        {/* Search Filter */}
      
      </div>
      <div style={{ marginTop: '20px' }}>
          <TableSearchFilter
            placeholder={`Search ${current ? "corporate" : "institute"}...`}
            //onChange={handleSearch}
            searchValue={search}
            setSearchValue={setSearch}
            withoutFilter={false}
            clearInput={clearInput}
            currentCount={current 
              ? 10 * page + (corporateList?.list?.length || 0) 
              : 10 * page + (instituteList?.result?.length || 0)
            }
            totalCount={current ? corporateList?.count : instituteList?.count}
          />
        </div>
      <CollegeTable 
        collegeList={collegeList}
        instituteList={instituteList}
        corporateList={corporateList}
        current={current}
        loading={isLoading}
        page={page}
        search={search}
        onPageChange={handlePageChange}
        setSearch={setSearch}
        setSort={setSort}
        setOrderBy={setOrderBy}
        orderBy={orderBy}
        sortBy={sort}
        filterData={filterData}
        setFilterData={setFilterData}
      />
    </SectionWrapper>
  )
}

export default CollegeTableMain
